import React, { useEffect, useState } from "react";
import {
  transformResultsToCompProfileData,
  formatBoldText,
} from "../../../../../services/commonService";
import InsightTable from "../../InsightTable";
import { useParams } from "react-router-dom";
import ParsedTextWithLinks from "../../../../HtmlElements/ParsedTextWithLinks";

function ProductLaunchesAndRelatedActivities({
  productLaunchesRelatedActivity,
  compView,
}) {
  const { clientName, competitorName } = useParams();
  const [tabData, setTabData] = useState([]);
  const [tableBelowDescription, setTableBelowDescription] = useState("");

  const [columns, setColumns] = useState([]);
  const [sidebarColumns, setSidebarColumns] = useState([]);
  const [hiddenColumns, setHiddenColumns] = useState([]);

  let allMetrics = [];
  useEffect(() => {
    if (compView === "quantitative") {
      allMetrics = [
        // { key: "name", label: "Name" },
        { key: "year", label: "Year" },
      ];

      setColumns(allMetrics);
      setHiddenColumns([]);
      setSidebarColumns([]);
    } else {
      allMetrics = [
        // { key: "name", label: "Name" },
        { key: "category", label: "Category" },
        { key: "year", label: "Year" },
        { key: "region", label: "Region" },
      ];

      setColumns(allMetrics);
      setHiddenColumns([]);
      setSidebarColumns([]);
    }
  }, [compView]);

  // const dummyData = [
  //   {
  //     name: {
  //       value: "Optifoam Gentle MAX",
  //     },
  //     category: {
  //       value: "Wound Care",
  //     },
  //     year: {
  //       value: "2023",
  //     },
  //     region: {
  //       value: "US",
  //     },
  //   },
  // ];

  useEffect(() => {
    // setTabData(dummyData);
    const transformed = transformResultsToCompProfileData(
      productLaunchesRelatedActivity
    );
    setTabData(transformed);

    setTableBelowDescription(
      // formatBoldText(
      //   productLaunchesRelatedActivity?.[0]?.response?.["tableComments"]
      // )
      <ParsedTextWithLinks
        text={
          productLaunchesRelatedActivity?.[0]?.response?.["tableComments"] || ""
        }
      />
    );
  }, [productLaunchesRelatedActivity]);

  const actions = [
    // { type: "chart", title: "Chart", onClick: () => {} },
    // { type: "conversation", title: "Conversation", onClick: () => {} },
    // { type: "mindMap", title: "Mind Map", onClick: () => {} },
    { type: "download", title: "Download", onClick: () => {} },
  ];

  const filtersConfig = [
    {
      key: "region",
      label: "Region",
      type: "dropdown",
      options: ["All", "US", "Global", "Europe", "Asia"],
      defaultValue: "All",
    },
    {
      key: "category",
      label: "Category",
      type: "dropdown",
      options: [
        "All",
        "Wound Care",
        "Surgical Logistics",
        "Dermatology",
        "Foot Care",
      ],
      defaultValue: "All",
    },
    {
      key: "year",
      label: "Year",
      type: "dropdown",
      options: ["All", "2023", "2024", "2025"],
      defaultValue: "All",
    },
  ];

  return (
    <div className="product_innovation_table_wrappper mb-2">
      <InsightTable
        title="Product Launches & Related Activities"
        subtitle={`Recent ${
          competitorName ?? "Tailored Chemical Products"
        } launches and related activities.`}
        // belowTableDescription={tableBelowDescription}
        defaultSortColumns={["year"]}
        data={tabData}
        metrics={columns}
        rowIdentifier={"name"}
        actions={actions}
        // filtersConfig={filtersConfig}
      />
    </div>
  );
}

export default ProductLaunchesAndRelatedActivities;
